import {Suspense} from 'react'
import {Outlet} from 'react-router-dom'
import {I18nProvider} from '../_metronic/i18n/i18nProvider'
import {LayoutProvider, LayoutSplashScreen} from '../_metronic/layout/core'
import {MasterInit} from '../_metronic/layout/MasterInit'
import {AuthInit} from './modules/auth'
import { TokenProvider } from './contexts/TokenProvider'
import Cookies from 'js-cookie'

const App = () => {
  const userId= Cookies.get("userId"); 
  const token= Cookies.get("token"); 
  
  return (
    <Suspense fallback={<LayoutSplashScreen />}>
      <I18nProvider>
        <LayoutProvider>
          <AuthInit>
          <TokenProvider initialId={userId} initialToken={token}>
            <Outlet />
          </TokenProvider>
            <MasterInit />
          </AuthInit>
        </LayoutProvider>
      </I18nProvider>
    </Suspense>
  )
}

export {App}
